import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setAllowEdit: YJSChangeHandler<DatabaseChangeType.SET_ALLOW_EDIT> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.allowEdit = change.allowEdit;
  });
};
